<template>
  <v-container>
    <v-card class="mx-auto rounded-xl">
      <v-row justify="center">
        <v-col cols="12">
          <v-card class="pa-4" elevation="4">
            <v-card-title>
              {{ isEditing ? 'Editar Cliente' : 'Novo Ciente' }}
            </v-card-title>
            <v-card-text>

              <v-tabs v-model="currentTab" dark class="mb-18">
                <v-tab value="details">Detalhes</v-tab>
              </v-tabs>

              <v-form ref="formRef" @submit.prevent="handleSubmit">
                <v-window v-model="currentTab" class="mt-2">
                  <v-window-item value="details">
                    <v-row class="mt-2">
                      <v-col cols="6">
                        <v-text-field v-model="formValue.name" label="Nome" :rules="[rules.name]"></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field v-model="formValue.phone" label="Telefone" v-maska="'(##) #####-####'"
                          :rules="[rules.phone]"></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field v-model="formValue.email" label="E-mail" :rules="[rules.email]"></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row class="mt-2">
                      <v-col cols="12" sm="6" md="3">
                        <v-switch v-model="formValue.is_active" color="success" label="Cliente Ativo?"></v-switch>
                      </v-col>
                    </v-row>

                  </v-window-item>
                </v-window>
              </v-form>
            </v-card-text>

            <v-card-actions class="d-flex justify-space-between">
              <v-btn color="secondary" variant="flat" @click="handleCancel">
                <v-icon left>mdi-arrow-left</v-icon>
                Voltar
              </v-btn>
              <v-btn color="primary" variant="flat" :loading="isSubmitting" :disabled="isSubmitting"
                @click="handleSubmit">
                <v-icon left>mdi-content-save</v-icon>
                {{ isEditing ? 'Salvar Alterações' : 'Cadastrar Cliente' }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { vMaska } from "maska/vue";
import api from '@/services/api';
import { useToastStore } from '@/store/toast';
import { useLoadingOverlay } from '@/store/loadingOverlay';

const toastStore = useToastStore();
const loadingOverlay = useLoadingOverlay();
const route = useRoute();
const router = useRouter();
const formRef = ref(null);

const currentTab = ref('details');
const isSubmitting = ref(false);

const formValue = ref({
  name: '',
  phone: '',
  email: '',
  is_active: true,
});

const isEditing = computed(() => !!route.params.id);

const rules = {
  name: v => !!v || 'O nome é obrigatório.',
  email: v => !!v || 'O e-mail é obrigatório.',
  phone: v => !!v || 'O Telefone é obrigatório.',
};

const loadClient= async (id) => {
  loadingOverlay.startLoading();
  try {
    const response = await api.get(`/client/${id}`);
    const data = response.data.data;

    if (data) {
      formValue.value = {
        name: data.name,
        phone: data.phone,
        email: data.email,
        is_active: data.is_active === 1,
      };
    } else {
      toastStore.showToast({ message: 'O cliente não foi encontrado.', color: 'warning' });
    }

  } catch (error) {
    console.error('Erro ao carregar os dados do cliente:', error);
    toastStore.showToast({
      message: error?.response?.data?.error || 'Erro ao carregar os dados do cliente',
      color: 'error',
    });
  } finally {
    loadingOverlay.stopLoading();
  }
};

const handleSubmit = async () => {
  const { valid } = await formRef.value.validate();
  if (!valid) {
    currentTab.value = 'details';
    return;
  }

  isSubmitting.value = true;

  const payload = { ...formValue.value };
  payload.is_active = payload.is_active ? 1 : 0;

  try {
    if (isEditing.value) {
      await api.put(`/clients/${route.params.id}`, payload);
    } else {
      await api.post('/clients', payload);
    }

    router.push('/app/clientes');
    toastStore.showToast({
      message: isEditing.value ? 'Cliente atualizado com sucesso!' : 'Cliente cadastrado com sucesso!',
      color: 'success',
    });

  } catch (error) {
    console.error('Erro ao salvar cliente:', error);
    toastStore.showToast({
      message: error?.response?.data?.error || 'Erro ao salvar cliente',
      color: 'error',
    });
  } finally {
    isSubmitting.value = false;
  }
};

const handleCancel = () => {
  router.push('/app/clientes');
};

onMounted(async () => {
  if (isEditing.value) {
    loadClient(route.params.id);
  }
});
</script>
